import React, { useState } from "react";
import "./Review_Modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, FormGroup } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Blue_Round_Btn from "../../common-btn/blue_round_btn/Blue_Round_Btn";
import Red_Round_Btn from "../../common-btn/red_round_btn/Red_Round_Btn";
import Success_Modal from "../success_modal/Success_Modal";
import StarRatings from "react-star-ratings";
import { useDispatch } from "react-redux";

import { postRating } from "../../../../features/rating/ratingSlice";
import { getOrder } from "../../../../features/order/orderSlice";

const Review_Modal = (props) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [rating, setRating] = useState(0);
  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    if (!rating || rating === 0) {
      setError("rating", { type: "manual", message: "Rating is required" });
      return;
    }
    data.ratings = rating;
    data.product_id = props?.product?.Product?.id;
    data.order_id = props?.order?.id;

    data.order_detail_id = props?.product?.id;
    const res = await dispatch(postRating(data));

    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(getOrder({ id:props.order?.id}));

      setSuccessmodal(true);
      setTimeout(() => {
        setSuccessmodal(false);
      }, 2000);
      reset();
      props?.onHide();
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  const [successmodal, setSuccessmodal] = useState(false);

  const countries = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const changeRating = (newRating) => {
    setRating(newRating);

  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Review_Modal"
      >
        <Modal.Body>
          <div className="reschedule_form">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="rating_div">
                  <StarRatings
                    rating={rating}
                    starRatedColor="#FFC107"
                    starHoverColor="#FFC107"
                    changeRating={(value) => {
                      setRating(value);
                      clearErrors("rating"); // clear error when user selects
                    }}
                    numberOfStars={5}
                    name="user-rating"
                    starDimension="25px"
                    starSpacing="1px"
                  />
                  {errors?.rating && (
                    <sup className="text-danger">{errors?.rating?.message}</sup>
                  )}
                </div>

                <div className="col-12">
                  <Form.Group
                    className="input_group"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Write Your Review</Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      {...register("review", {
                        required: "review is required",
                      })}
                    />
                    {errors?.review && (
                      <sup className="text-danger">
                        {errors?.review?.message}
                      </sup>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                <Blue_Round_Btn btnText="Submit" type="submit" />
                <Red_Round_Btn
                  btnText={"Close"}
                  onClick={() => {
                    props?.onHide();
                  }}
                />
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={successmodal}
        onHide={() => setSuccessmodal(false)}
        successText={"Review Submited Successfully !"}
      />
    </>
  );
};

export default Review_Modal;
